import Model from 'flarum/common/Model';
export default class LinkedAccount extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  priority() {
    return Model.attribute('priority').call(this);
  }
  linked() {
    return Model.attribute('linked').call(this);
  }
  orphaned() {
    return Model.attribute('orphaned').call(this);
  }
  identifier() {
    return Model.attribute('identifier').call(this);
  }
  firstLogin() {
    return Model.attribute('firstLogin', Model.transformDate).call(this);
  }
  lastLogin() {
    return Model.attribute('lastLogin', Model.transformDate).call(this);
  }
  userId() {
    return Model.attribute('userId').call(this);
  }
}
flarum.reg.add('fof-oauth', 'forum/models/LinkedAccount', LinkedAccount);